"use client";

import React from "react";
import logo from "../images/newLogo.webp";
import { CustomLink } from "./CustomLink";

export default function Header() {
  return (
    <div className="flex w-full items-center justify-between bg-white px-6 py-[15px] md:px-14">
      <div className="flex items-center">
        <CustomLink href="/">
          <img
            className="h-[54px] w-[163px] cursor-pointer"
            src={logo}
            alt="logo img"
          />
        </CustomLink>
      </div>
    </div>
  );
}
